import { ReactNode } from "react";
import { DefaultTenant, TenantContext } from "./TenantContext";

interface Props {
  children: ReactNode;
}

export const TenantProvider = ({ children }: Props) => {
  return (
    <TenantContext.Provider
      value={{ tenant: DefaultTenant, isTenantLoading: false }}
    >
      {children}
    </TenantContext.Provider>
  );
};
